import { render, staticRenderFns } from "./Leader.vue?vue&type=template&id=3d4e76e6"
import script from "./Leader.vue?vue&type=script&lang=js"
export * from "./Leader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports